import { useMemo, useState } from 'react'
import classNames from 'classnames'
import {
  distributeAssetsByCategory,
  getLandingUrlState,
  joinAssetNames,
  stripKeywordTag,
} from 'features/creative/creativeUtil'
import NoneAnchor from 'components/NoneAnchor'
import { shallowEqual, useSelector } from 'react-redux'
import { BizChannelTypes } from '../../../Codes'
import MixedTalkChannelPreview from '../../preview/MixedTalkChannelPreview'

const ImportPreview = () => {
  const {
    creativeAdd: { bizChannelType, selectedChannel },
    creativeImport: {
      creativeDetail: creative,
      creativeDetail: { title = '', description = '', assets },
    },
  } = useSelector(state => state.creative, shallowEqual)
  const [isMobileView, setMobileView] = useState(true)
  const { individual, mobileUrl, pcUrl } = useMemo(
    () =>
      getLandingUrlState({
        individualSettingYn: selectedChannel?.siteUrl?.individualSettingYn,
        mobileLandingUrl: selectedChannel?.siteUrl?.mobileUrl,
        pcLandingUrl: selectedChannel?.siteUrl?.pcUrl,
      }),
    [selectedChannel]
  )
  const assetInfo = useMemo(
    () => distributeAssetsByCategory(assets.map(({ type }) => type)),
    [assets]
  )
  const viewUrl = useMemo(() => {
    if (individual) {
      if (isMobileView) {
        return mobileUrl || pcUrl || 'http://m.ooooo.com'
      } else {
        return pcUrl || mobileUrl || 'http://wwww.ooooo.com'
      }
    } else {
      return mobileUrl || 'http://www.ooooo.com'
    }
  }, [individual, isMobileView, mobileUrl, pcUrl])
  return (
    <div className="view_material">
      <div className="view_tit">
        <strong className="tit_view">
          {bizChannelType === BizChannelTypes.TALK_CHANNEL
            ? '추천소재'
            : '기본소재'}
        </strong>
        <ul className="tab_view">
          {bizChannelType === BizChannelTypes.TALK_CHANNEL ? (
            <li className="on">
              <NoneAnchor className="link_tab">모바일 전용</NoneAnchor>
            </li>
          ) : (
            <>
              <li className={classNames({ on: isMobileView })}>
                <NoneAnchor
                  className="link_tab"
                  onClick={() => setMobileView(true)}>
                  모바일
                </NoneAnchor>
              </li>
              <li className={classNames({ on: !isMobileView })}>
                <NoneAnchor
                  className="link_tab"
                  onClick={() => setMobileView(false)}>
                  PC
                </NoneAnchor>
              </li>
            </>
          )}
        </ul>
      </div>
      {bizChannelType === BizChannelTypes.TALK_CHANNEL ? (
        <MixedTalkChannelPreview
          channel={selectedChannel}
          creative={creative}
        />
      ) : (
        <>
          <div
            className={classNames('view_detail', {
              view_mo: isMobileView,
              view_pc: !isMobileView,
            })}>
            <div className="material_default">
              <div className="inner_cont">
                <strong className="ad_subject">{stripKeywordTag(title)}</strong>
                <div className="ad_link">
                  {isMobileView && <span className="ico_ad">광고</span>}
                  <span className="txt_link">{viewUrl}</span>
                </div>
                <div className="ad_info">
                  <span className="ad_desc">
                    {stripKeywordTag(description)}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="view_existing">
            <div className="view_tit">
              <strong className="tit_view">
                확장 소재{' '}
                <span className="fc_emph">
                  {assetInfo.image.length +
                    assetInfo.text.length +
                    assetInfo.button.length +
                    assetInfo.link.length}
                </span>
              </strong>
            </div>
            <strong className="screen_out">소재 검색 상세 리스트</strong>
            <div className="list_existing">
              <dl>
                <dt>
                  · 이미지형{' '}
                  <span className="fc_emph">{assetInfo.image.length}</span>
                </dt>
                <dd>{joinAssetNames(assetInfo.image)}</dd>
                <dt>
                  · 텍스트형{' '}
                  <span className="fc_emph">{assetInfo.text.length}</span>
                </dt>
                <dd>{joinAssetNames(assetInfo.text)}</dd>
                <dt>
                  · 버튼형{' '}
                  <span className="fc_emph">{assetInfo.button.length}</span>
                </dt>
                <dd>{joinAssetNames(assetInfo.button)}</dd>
                <dt>
                  · 연동형{' '}
                  <span className="fc_emph">{assetInfo.link.length}</span>
                </dt>
                <dd>{joinAssetNames(assetInfo.link)}</dd>
              </dl>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default ImportPreview
